(function () {
  'use strict';

  var lightbox = null;
  var lightboxImg = null;
  var lastFocus = null;

  function buildLightbox() {
    lightbox = document.createElement('div');
    lightbox.className = 'luxe-strip-lightbox';
    lightbox.setAttribute('role', 'dialog');
    lightbox.setAttribute('aria-modal', 'true');
    lightbox.hidden = false;

    lightboxImg = document.createElement('img');
    lightboxImg.className = 'luxe-strip-lightbox__img';
    lightboxImg.decoding = 'async';

    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'luxe-strip-lightbox__close';
    close.setAttribute('aria-label', 'Close');
    close.innerHTML = '<svg viewBox="0 0 12 12" aria-hidden="true"><path d="M1 1 L11 11 M11 1 L1 11" stroke="currentColor" stroke-width="1.5" fill="none" stroke-linecap="round"/></svg>';

    lightbox.appendChild(lightboxImg);
    lightbox.appendChild(close);
    document.body.appendChild(lightbox);

    close.addEventListener('click', closeLightbox);
    // the backdrop closes, the picture itself does not
    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox) closeLightbox();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && lightbox.classList.contains('is-open')) closeLightbox();
    });
    // Lenis and the scene drivers both read presses at the window
    ['pointerdown', 'pointerup'].forEach(function (evt) {
      lightbox.addEventListener(evt, function (e) { e.stopPropagation(); });
    });
  }

  function openLightbox(src, alt) {
    if (!lightbox) buildLightbox();
    lastFocus = document.activeElement;
    lightboxImg.src = src;
    lightboxImg.alt = alt;
    document.documentElement.classList.add('luxe-strip-lock');
    requestAnimationFrame(function () { lightbox.classList.add('is-open'); });
    lightbox.querySelector('.luxe-strip-lightbox__close').focus();
  }

  function closeLightbox() {
    if (!lightbox) return;
    lightbox.classList.remove('is-open');
    document.documentElement.classList.remove('luxe-strip-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  var strips = document.querySelectorAll('[data-luxe-strip]');

  strips.forEach(function(strip) {
    var track = strip.querySelector('[data-strip-track]');
    if (!track) return;
    var items = Array.from(track.querySelectorAll('.luxe-strip__item'));
    if (!items.length) return;

    var numOriginals = items.length;

    items.forEach(function (item) {
      var cloneBefore = item.cloneNode(true);
      var cloneAfter = item.cloneNode(true);
      track.insertBefore(cloneBefore, items[0]);
      track.appendChild(cloneAfter);
    });

    var allItems = track.querySelectorAll('.luxe-strip__item');

    var isDragging = false;
    var startX = 0;
    var currentIndex = numOriginals;
    var deltaX = 0;
    var isAnimating = false;

    function getVisibleCount() {
      // must track --strip-visible in luxe-strip.css: the wrap maths below
      // counts slides, and a mismatch shows a blank run at the seam
      return window.innerWidth <= 820 ? 1 : 3;
    }

    function getItemWidth() {
      return allItems[0].getBoundingClientRect().width;
    }

    function getGap() {
      var gapStr = window.getComputedStyle(track).getPropertyValue('gap');
      return parseFloat(gapStr) || 0;
    }

    function getSlideDistance() {
      return getItemWidth() + getGap();
    }

    function updateTransform(instant) {
      var distance = getSlideDistance();
      var tx = -(currentIndex * distance) + (isDragging ? deltaX : 0);

      if (instant) {
        track.style.transition = 'none';
      } else {
        track.style.transition = '';
      }

      track.style.setProperty('--tx', tx + 'px');

      if (instant) {
        void track.offsetWidth;
        track.style.transition = '';
      }
    }

    track.addEventListener('transitionend', function(e) {
      if (e.target !== track || e.propertyName !== 'transform') return;
      isAnimating = false;

      var changed = false;

      if (currentIndex <= numOriginals - getVisibleCount()) {
        currentIndex += numOriginals;
        changed = true;
      }
      else if (currentIndex >= numOriginals * 2) {
        currentIndex -= numOriginals;
        changed = true;
      }

      if (changed) {
        updateTransform(true);
      }
    });

    track.addEventListener('pointerdown', function (e) {
      if (isAnimating) return;
      isDragging = true;
      startX = e.clientX;
      deltaX = 0;
      track.classList.add('is-dragging');
      track.setPointerCapture(e.pointerId);
    });

    track.addEventListener('pointermove', function (e) {
      if (!isDragging) return;
      deltaX = e.clientX - startX;
      updateTransform(true);
    });

    function endDrag() {
      if (!isDragging) return;
      isDragging = false;
      track.classList.remove('is-dragging');

      var distance = getSlideDistance();
      var threshold = distance * 0.15;

      if (deltaX < -threshold) {
        currentIndex++;
        isAnimating = true;
      } else if (deltaX > threshold) {
        currentIndex--;
        isAnimating = true;
      }

      deltaX = 0;
      updateTransform(false);
    }

    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);

    window.addEventListener('resize', function () {
      updateTransform(true);
    });

    /* ---------------- auto-advance ----------------
       Drives exactly what a forward drag does, so the infinite wrap in the
       transitionend handler above carries it — there is no second notion of
       position to keep in step.

       It backs off rather than fighting the visitor: paused while a drag is in
       progress, while the pointer rests on the strip, while a slide is still
       easing, and while the tab is in the background. An IntersectionObserver
       stops the timer entirely when the strip is off screen, so six of these
       on a page are not all ticking at once. */
    var AUTO_MS = 3000;
    var autoTimer = null;
    var hovered = false;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function autoStep() {
      if (hovered || isDragging || isAnimating || document.hidden) return;
      currentIndex++;
      isAnimating = true;
      updateTransform(false);
    }

    function startAuto() {
      if (reduceMotion || autoTimer) return;
      autoTimer = setInterval(autoStep, AUTO_MS);
    }

    function stopAuto() {
      if (!autoTimer) return;
      clearInterval(autoTimer);
      autoTimer = null;
    }

    // mouseenter/leave rather than pointerenter/leave: a pointerenter fires on
    // touch too and never pairs with a leave, which would strand it paused
    strip.addEventListener('mouseenter', function () { hovered = true; });
    strip.addEventListener('mouseleave', function () { hovered = false; });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stopAuto(); else startAuto();
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) startAuto(); else stopAuto();
      }, { threshold: 0.15 }).observe(strip);
    } else {
      startAuto();
    }

    /* ---------------- tap to enlarge ----------------
       One lightbox for the whole page, built on first use — the full-size
       image is only fetched when someone actually asks for it.

       A press that turned into a drag is ignored, or spinning the strip would
       open a frame every time it came to rest. */
    strip.addEventListener('click', function (e) {
      if (isDragging || Math.abs(deltaX) > 4) return;
      var fig = e.target.closest ? e.target.closest('.luxe-strip__item') : null;
      if (!fig) return;
      var img = fig.querySelector('.luxe-strip__img');
      if (img) openLightbox(img.currentSrc || img.src, img.alt || '');
    });

    updateTransform(true);
  });
})();
